import useExcedeStatus from '../hooks/useExcedeStatus.js';

export default function ExcedeBanner() {
  const { connected, utsccReachable } = useExcedeStatus();

  if (connected && utsccReachable) return null;

  const msg = !connected
    ? 'Excede tunnel is offline. Start the UTSales Tunnel Agent on the office PC.'
    : 'Office PC is not connected to UTSCC network. Connect physically or start Sophos VPN.';

  return (
    <div className="bg-amber-50 border-b border-amber-300 px-4 py-2 text-sm text-amber-800 flex items-center gap-2">
      <span className="text-base">⚠</span>
      <span>{msg} Excede data (customers, orders, parts) is unavailable.</span>
    </div>
  );
}
